export default "__VITE_ASSET__7ffdbb15__"